import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Mail, Eye, Send, Loader2 } from "lucide-react";

export const MonthlyBlueprint = () => {
  const [html, setHtml] = useState("");
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [testEmail, setTestEmail] = useState("");

  const preview = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/notifications/monthly-blueprint/preview");
      setHtml(data.html); setOpen(true);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const send = async () => {
    if (!window.confirm("Send this month's blueprint email to all your linked clients now?")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/notifications/monthly-blueprint");
      toast.success(`Queued to ${data.recipients} client${data.recipients === 1 ? "" : "s"} for ${data.period}`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  const sendTest = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/notifications/monthly-blueprint/test", testEmail ? { email: testEmail } : {});
      toast.success(`Test blueprint sent to ${data.to}`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="monthly-blueprint" className="rounded-2xl border border-black/5 bg-white p-6 shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
      <h2 className="font-serif text-2xl text-emerald-950 flex items-center gap-2"><Mail className="w-5 h-5 text-emerald-700" /> Monthly Client Blueprint</h2>
      <p className="mt-1 text-xs text-stone-400">Seasonal turf &amp; hydroponics service email. Auto-sends to all clients on the 1st of each month — or send now.</p>
      <div className="mt-4 flex flex-wrap gap-2">
        <Button data-testid="blueprint-preview-btn" variant="outline" onClick={preview} disabled={busy} className="rounded-full">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Eye className="w-4 h-4 mr-1" /> Preview this month</>}
        </Button>
        <Button data-testid="blueprint-test-btn" variant="outline" onClick={sendTest} disabled={busy} className="rounded-full">
          <Send className="w-4 h-4 mr-1" /> Send test
        </Button>
        <Input data-testid="blueprint-test-email" type="email" value={testEmail} onChange={(e) => setTestEmail(e.target.value)} placeholder="test to this email (optional)" className="rounded-full max-w-[240px]" />
        <Button data-testid="blueprint-send-btn" onClick={send} disabled={busy} className="rounded-full bg-emerald-900 hover:bg-emerald-800 text-white">
          <Send className="w-4 h-4 mr-1" /> Send now to my clients
        </Button>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-2xl max-h-[80vh] overflow-auto">
          <DialogHeader><DialogTitle>This month's blueprint preview</DialogTitle></DialogHeader>
          <div data-testid="blueprint-preview-body" dangerouslySetInnerHTML={{ __html: html }} />
        </DialogContent>
      </Dialog>
    </div>
  );
};
